/*
 * @Date: 2019-08-09 19:49:42
 * @LastEditors: hzgegenhasi@corp.netease.com
 * @LastEditTime: 2019-08-09 19:49:42
 * @Author: hzgegenhasi@corp.netease.com
 */
import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { Type } from './redux';

/**
 * 获取转码状态
 */

const getResourceStatus = (action$, state$, { fetch }) => {
  return action$.pipe(
    ofType(Type.GET_RESOURCE_STATUS),
    switchMap(({ contentId, contentType }) =>
      fetch({
        url: '/web/j/resourceRpcBean.getResourceStatus.rpc',
        body: {
          contentId,
          contentType,
        },
      }),
    ),
    map(res => ({
      type: Type.GET_RESOURCE_STATUS_SUCCESS,
      resourceStatus: res,
    })),
  );
};

export default [getResourceStatus];
